import React, { useCallback } from "react";
import styled from "styled-components";
import logoImg from "assets/images/logo_alternate.png";
import { useHistory } from "react-router";

const Img = styled.img`
  cursor: pointer;
  object-fit: contain;
  filter: drop-shadow(5px 7px 2px rgba(0, 0, 0, 1)); /* x-offset, y-offset, blur-radius, color */
`;

export const Logo = ({ width, height }) => {
  const history = useHistory();

  const handleClick = useCallback(() => {
    history.push("/");
  }, [history]);

  return <Img src={logoImg} height={height || 55} onClick={handleClick} />;
};
